/**
 * FaceOverlayLayer — renders a list of FaceOverlay components for the
 * Edit page. Encapsulates the previously-duplicated map block (one for
 * crop mode, one for the standard viz/edit overlay) so both call sites
 * use the same iteration + callback wiring.
 *
 * Tank Redesign port (PR 9.1): mechanical extraction — same JSX, same
 * props, same FaceOverlay behavior. The face overlay coordinate logic
 * (with the `loaded_from_output` plumbing fixed in `1355096`) remains
 * inside FaceOverlay itself; this layer only owns the iteration shell.
 */

import FaceOverlay from '../../../../components/edit/FaceOverlay';

export default function FaceOverlayLayer({
  faces,
  selectedFace,
  hoverFace,
  hoveredPersonId,
  showPersonModal,
  viewMode,
  imgDims,
  cropBox,
  imgBounds,
  vizNaturalDims,
  resolveClickedFace,
  containerRef,
  onSelect,
  onUnassign,
  onIgnore,
  onUnignore,
  onRemoveSource,
  onHoverFace,
  onOpenPersonModal,
}) {
  if (!faces || faces.length === 0) return null;

  return faces.map((f) => {
    const label =
      f.person_name ||
      f.person_display ||
      f.person?.display_name ||
      null;
    return (
      <FaceOverlay
        key={f.id}
        face={f}
        personLabel={label}
        selected={selectedFace?.id === f.id}
        isHovered={
          hoverFace?.id === f.id ||
          (hoveredPersonId &&
            (f.person === hoveredPersonId || f.person_id === hoveredPersonId))
        }
        onHover={onHoverFace}
        onSelect={(face, open, e) => {
          if (showPersonModal) return; // Don't change selection while modal is open.
          if (face?._unassign) {
            onUnassign(face);
            return;
          }
          const resolved = e
            ? resolveClickedFace(e, faces, containerRef.current, viewMode, imgDims, cropBox)
            : null;
          const target = resolved || face;
          onSelect(target);
          if (open) onOpenPersonModal({ face: target });
        }}
        onIgnore={onIgnore}
        onUnignore={onUnignore}
        onRemoveSource={onRemoveSource}
        dims={imgDims}
        cropBox={cropBox}
        viewMode={viewMode}
        imgBounds={imgBounds}
        vizNaturalDims={vizNaturalDims}
        mode="edit"
      />
    );
  });
}
